// extracted by mini-css-extract-plugin
export default {"container":"theme_container__Vkwrr","postsList":"theme_postsList__G6yaA","postDetails":"theme_postDetails__smUiI"};